import {
  ModalDialog,
  ModalDialogBodyContent,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {AboutYouLogo} from '../../AboutYouLogo/AboutYouLogo';
import {DOLInfoBody} from './DOLInfoBody';

export const DOLInfoModal = ({
  isOpen,
  showItemNumberArrow,
  showTrackingNumberArrow,
  onClose,
}: {
  isOpen: boolean;
  showTrackingNumberArrow?: boolean;
  showItemNumberArrow?: boolean;
  onClose: VoidFunction;
}) => {
  return (
    <StyledModalDialog
      open={isOpen}
      contentFitWidth
      renderInPortal
      zIndex={Z_INDEXES.SUSTAINABILITY_MODAL_DIALOG}
      fixedSmallWidth={false}
      data-testid="DeclarationOfLossInfo"
      headerContent={
        <AboutyouLogoWrapper>
          <AboutYouLogo />
        </AboutyouLogoWrapper>
      }
      onClose={onClose}
      bodyContent={
        <DOLInfoBody
          showItemNumberArrow={showItemNumberArrow}
          showTrackingNumberArrow={showTrackingNumberArrow}
        />
      }
    />
  );
};

const AboutyouLogoWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const StyledModalDialog = styled(ModalDialog)`
  ${ModalDialogBodyContent} {
    padding: 0;
  }
`;
